//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { Activity, Enums } from "../../models/common"

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"

//#region Public Types

export const REPORT_CONTEXT_MENU_SERVICE_NAME = 'reportContextMenuService'
export const REPORT_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'reportContextMenuServiceProvider'

export type IdReportGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onEdit?: (e: any) => void
    onReportGenerate?: (e: any) => void
}

//#endregion

export class ReportContextMenuService {

    // #region Ctor

    public constructor(
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: IdReportGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        if (options.onEdit != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.REPORT_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),

                onItemClick: (e: any) => {
                    options.onEdit(e)
                }
            })
        }

        if (
            _.size(options.idReferenceTypes) === 1
            && this.userSessionService.getLoggedOperator().hasPermission(Activity.REPORT_GENERATE_OP)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.REPORT_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.ReportGenereation)
        ) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(
                    LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__GENERATE, Enums.SimaxModuleName.Report),
                    ConfigHelper.Icon.REPORT_GENERATE,
                    this.userSessionService
                ),

                onItemClick: (e: any) => {
                    options.onReportGenerate(e)
                },
            })
        }

        return items
    }

    // #endregion
}

export class ReportContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSessionService: UserSessionService) {
        return new ReportContextMenuService(userSessionService)
    }]

    //#endregion
} 
